import React from 'react'
import { Modal, ModalHeader, Col, ModalBody, Row, Button } from 'reactstrap';
// import './StyleModalPatients.css'
import { TableStriped } from '../../components/tables/TableStriped';
import { Dialog } from 'primereact/dialog';


export const ModalMassLoadErrors = (props) => {

    const {

        // ? DIALOG
        modal,
        toggle,

        // ? PAGINATION TABLE
        goNextPage,
        goPreviousPage,
        goToPage,
        actualPage,
        totalPages,

        // ? MASSIVE FILE
        downloadMassiveSampligFile,
        massiveSamplig,

    } = props;

    let _newErrorMassive = []

    massiveSamplig.records.forEach((record, index) => {
        if (record.error) {
            _newErrorMassive.push({
                key: index,
                name: record.nombre,
                paternalSurname: record.apellido_paterno,
                maternalSurname: record.apellido_materno,
                birthdate: record.fecha_nacimiento,
                gender: record.genero,
                error: record.error
            })
        }

    });
    return (
        <Dialog
            visible={modal}
            onHide={toggle}
            modal
            maskClassName="custom-total-mask"
            draggable={false}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="pi pi-times-circle"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Errores de muestreo
                            </div>
                        </div>

                    </div>
                </div>
            }
            className={`Global-dialog Global-dialog Global-blue Global-small-v2 `}

        >
            <Col sm="12" className='pt-3 p-l-0 p-r-0' >
                <div className="table-responsive custom-massive-table">
                    {
                        _newErrorMassive.length > 0 ? (
                            <TableStriped
                                cabeceras={["Nombres", "Apellido paterno", "Apellido materno", "Fecha de nacimiento", "Género", "Errores"]}
                                items={_newErrorMassive}
                                nextPage={goNextPage}
                                previousPage={goPreviousPage}
                                totalPageCount={totalPages}
                                currentPage={actualPage}
                                goToPage={goToPage}
                                paginingBack={true}
                            />
                        ) : (
                            <div style={{ textAlign: "-webkit-center" }}>
                                <img
                                    className="img-fluid"
                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    style={{ width: "32%" }}
                                    alt="Sin resultados"
                                />
                                <br />
                                <p className='f-14 badge badge-light-primary'>
                                    No se encontraron errores en la carga masiva.
                                </p>
                            </div>
                        )
                    }
                </div>
                <br />
            </Col>
            <br />
            <Row>
                <Col className='text-right' xs="12" sm="12" md="12" lg="12" xl="12">
                    {
                        _newErrorMassive.length > 0 ? (
                            <Button
                                type="button"
                                outline
                                color="primary"
                                size='sm'
                                className={`mt-1 text-center ${massiveSamplig.fileReport ? '' : 'disabled'}`}
                                onClick={() => massiveSamplig.fileReport && downloadMassiveSampligFile(massiveSamplig.fileReport)}
                            >
                                Descargar
                            </Button>
                        ) : null
                    }
                </Col>
            </Row>
        </Dialog >
    )
}
